import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Wrapper } from "src/types/wrapper";
import { HistoryContext } from "src/context/historyContext";

const MAX_HISTORY_LENGTH = 5;

const HistoryProvider: Wrapper = ({ children }) => {
  const [history, setHistory] = useState<string[]>([]);
  const location = useLocation();

  useEffect(() => {
    setHistory((prevHistory) => {
      const history = [...prevHistory, `${location.pathname}${location.search}`];
      if (history.length > MAX_HISTORY_LENGTH) {
        return history.slice(-MAX_HISTORY_LENGTH);
      }
      return history;
    });
  }, [location]);

  return <HistoryContext.Provider value={{ history }}>{children}</HistoryContext.Provider>;
};

export default HistoryProvider;
